
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { monoDataCellSx } from "styles/tokens/typography";

function DataTableBodyCell({ noBorder, align, fixedLayout, children }) {
  // PSA-373: narrow/resized columns wrap onto the next line instead of "...".
  return (
    <MDBox
      component="td"
      data-table-data-cell
      textAlign={align}
      py={1}
      px={2}
      sx={({ palette }) => ({
        fontSize: "0.875rem",
        borderBottom: noBorder ? "none" : `1px solid ${palette.grey?.[200] || "#ECF1F8"}`,
        verticalAlign: "middle",
        maxWidth: fixedLayout ? "none" : 280,
        ...monoDataCellSx,
      })}
    >
      <MDBox
        display="block"
        width="100%"
        color="text"
        sx={{
          verticalAlign: "middle",
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          lineHeight: 1.35,
          ...monoDataCellSx,
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  fixedLayout: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  fixedLayout: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
